import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const CassarFeriasService = {
  async postCassarFerias(postData) {

    const response = await BaseService.fetchResponseFromAPIPost(
      `cassacaoferias`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule(await response.message, "success");
    return true;
  },

  async getByIdFerias(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`cassacaoferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async aprovarCassacaoFerias(id,postData) {
    postData.append("_method", "PUT");
    const response = await BaseService.fetchResponseFromAPIPost(
      `cassacaoferias/aprovar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule(await response.message, "success");
    return true;
  },

  async recusarCassacaoFerias(id,postData) {
    postData.append("_method", "PUT");
    const response = await BaseService.fetchResponseFromAPIPost(
      `cassacaoferias/recusar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule("Cassação recusada com sucesso.", "success");
    return true;
  },
}